import { FormikProps } from 'formik';
import {
  SocialInput,
  EmailInput,
  OutputQuantity,
  PersonaSocialInput,
  PersonaEmailInput,
} from '../../../../../types/FormTypes';
import { BasicButtonSelectionInput } from '../../../../shared/inputs/BasicButtonSelectionInput';

type OutputQuantityInputsProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
};

export function OutputQuantityInputs<T extends SocialInput | EmailInput | PersonaEmailInput | PersonaSocialInput>({
  formikProps,
  disabled,
}: OutputQuantityInputsProps<T>) {
  return (
    <BasicButtonSelectionInput
      id="multipleOutputs"
      label={
        <div>
          <h2>Number of generated outputs</h2>
          <p>Please select preference.</p>
        </div>
      }
      defaultOptions={Object.values(OutputQuantity)}
      value={formikProps.values.multipleOutputs}
      disabled={disabled}
      errors={formikProps.errors.multipleOutputs as string}
      setValue={(newValue) => {
        // Only set new value if it exists
        // The default behavior is clicking an option twice deselects it
        if (newValue) {
          formikProps.setFieldValue('multipleOutputs', newValue);
        }
      }}
      touched={formikProps.touched.multipleOutputs ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}
